import flow from 'lodash/flow';
import { AnalyticsSource } from '@atlassian/jira-analytics-web-react/src/components/decorators.tsx';
import { SCREEN } from '@atlassian/jira-product-analytics-bridge';
import { connect } from '@atlassian/jira-react-redux';
import { getCurrentEstimationStatistic } from '../state/selectors/chart';
import {
	getSprintFetchError,
	getSprintFetchProgress,
	getSprintFetchProgressUpdate,
	getSprintFetchStatus,
	getSprints,
} from '../state/selectors/sprints';
import type { State } from '../state/types';
import Chart from './chart';
import Grid from './grid';
import VelocityReportAsync, { type Props } from './view';

const mapStateToProps = (
	state: State,
): Omit<Props, 'onExperienceSuccess' | 'onExperienceFailure'> => ({
	// @ts-expect-error - TS2322 - Type 'ComponentClass<Omit<WithIntlProps<Intl & Props>, string>> & { WrappedComponent: Component<WithIntlProps<Intl & Props>>; }' is not assignable to type 'ComponentType<Record<any, any>>'.
	Chart,
	Grid,
	sprints: getSprints(state),
	sprintFetchStatus: getSprintFetchStatus(state),
	sprintFetchProgress: getSprintFetchProgress(state),
	sprintFetchProgressUpdate: getSprintFetchProgressUpdate(state),
	sprintFetchError: getSprintFetchError(state),
	estimationStatistic: getCurrentEstimationStatistic(state),
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const mapDispatchToProps: Record<string, any> = {};

export default flow(
	AnalyticsSource('velocityChart', SCREEN),
	// @ts-expect-error - TS2589 - Type instantiation is excessively deep and possibly infinite.
	connect(mapStateToProps, mapDispatchToProps),
)(VelocityReportAsync);
